import { useRef, useState } from "react";

// Push-to-talk recorder: returns a Blob (webm/ogg/mp4 depending on browser) when stopped.
export const useRecorder = () => {
  const [recording, setRecording] = useState(false);
  const recRef = useRef(null);
  const chunks = useRef([]);
  const resolver = useRef(null);

  const start = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    const mime = ["audio/webm;codecs=opus", "audio/webm", "audio/mp4", "audio/ogg"].find((t) => window.MediaRecorder?.isTypeSupported?.(t)) || "";
    const rec = new MediaRecorder(stream, mime ? { mimeType: mime } : undefined);
    chunks.current = [];
    rec.ondataavailable = (e) => e.data.size && chunks.current.push(e.data);
    rec.onstop = () => {
      stream.getTracks().forEach((t) => t.stop());
      resolver.current?.(new Blob(chunks.current, { type: rec.mimeType || "audio/webm" }));
      resolver.current = null;
    };
    rec.start();
    recRef.current = rec;
    setRecording(true);
  };

  const stop = () =>
    new Promise((resolve) => {
      const rec = recRef.current;
      if (!rec || rec.state === "inactive") return resolve(null);
      resolver.current = resolve;
      rec.stop();
      setRecording(false);
    });

  return { recording, start, stop, supported: typeof window !== "undefined" && Boolean(navigator.mediaDevices?.getUserMedia && window.MediaRecorder) };
};
